/* eslint array-callback-return: 0 */
import { request } from './auth-actions'

import {
  BATCH_IMPORT_ACTIVE,
  BATCH_IMPORT_FAILED,
  BATCH_IMPORT_SUCCESS,
  CLEAR_PREVIOUS_IMPORT,
  NOTIFY_DANGER,
  NOTIFY_SUCCESS,
} from './action-types'

import { notify } from './notification-actions'
import userUploadServiceApi from '../../api/user-upload-service-api'
import { getText } from '../../internal/TextLabels'
import { silentError } from './action-utils'

export const batchImportActive = () => ({ type: BATCH_IMPORT_ACTIVE })

export const batchImportFailed = () => ({ type: BATCH_IMPORT_FAILED })

export const batchImportSuccess = file => ({
  type: BATCH_IMPORT_SUCCESS,
  file,
})

export const clearPreviousImport = () => ({ type: CLEAR_PREVIOUS_IMPORT })

const genericImportError = () => {
  notify(NOTIFY_DANGER, getText('user.import.messages.generalError'))
}

export const showImportErrors = response => {
  const errorMsg = []
  if (response.errors.length > 0) {
    response.errors.map(error => {
      let msg = ''
      if (error?.message?.includes('username')) {
        msg = getText('user.import.messages.username')
      } else if (error?.message?.includes('email')) {
        msg = getText('user.import.messages.email')
      }
      errorMsg.push(
        getText('user.import.messages.lineError', '', error.lineNumber, msg),
      )
    })
  }
  return {
    recordsRead: response.recordsRead,
    recordsImported: response.recordsImported,
    errors: errorMsg,
  }
}

const handleImport = (data, file) => dispatch => {
  if (data.recordsImported === data.recordsRead && data.recordsImported > 0) {
    dispatch(batchImportSuccess(file))
    notify(
      NOTIFY_SUCCESS,
      getText(
        'user.import.messages.importSuccess',
        data.recordsImported,
        data.recordsRead,
        file.name,
      ),
    )
  } else if (data.recordsImported === data.recordsRead) {
    dispatch(batchImportFailed())
    notify(NOTIFY_DANGER, getText('user.import.messages.noImport'))

    throw data
  } else {
    dispatch(batchImportFailed())

    throw data
  }
}

export const showValidationErrors = response => {
  const errorMsg = []
  if (!response.validationErrors) {
    errorMsg.push(response.message)
  } else {
    response.validationErrors.map(error => {
      let errMsg = ''
      switch (error.fieldName) {
        case 'stores':
        case 'stores[]':
          errMsg = getText(
            'user.import.messages.validationStore',
            response.lineNumber,
          )
          break
        case 'userName':
        case 'username':
          errMsg = getText(
            'user.import.messages.validationUsername',
            response.lineNumber,
          )
          break
        case 'email':
          errMsg = getText(
            'user.import.messages.validationEmail',
            response.lineNumber,
          )
          break
        case 'firstName':
          errMsg = getText(
            'user.import.messages.validationFirstname',
            response.lineNumber,
          )
          break
        case 'lastName':
          errMsg = getText(
            'user.import.messages.validationLastname',
            response.lineNumber,
          )
          break
        case 'phoneNumber':
          errMsg = getText(
            'user.import.messages.validationPhonenumber',
            response.lineNumber,
          )
          break
        default:
          break
      }
      if (!errorMsg.includes(errMsg)) {
        errorMsg.push(errMsg)
      }
    })
  }

  return errorMsg
}

export const batchImportUsers = file => dispatch => {
  dispatch(batchImportActive())

  return dispatch(request(userUploadServiceApi.batchImportUsers, file))
    .then(data => {
      dispatch(handleImport(data, file[0]))
    })
    .catch(error => {
      silentError(error)
      dispatch(batchImportFailed())
      if (error.status >= 500) {
        genericImportError()
        return
      }
      throw error
    })
}
